import { FullScreenPageContainer } from '@/components/utils/FullScreenPageContainer';
import usePasswordRecovery from '@/hooks/usePasswordRecovery';
import { Button } from '@design-system/Button';
import { DataForm } from '@design-system/DataForm/DataForm';
import { TextField } from '@design-system/DataForm/TextField';

export const PasswordRecovery = () => {
  const { onValid, form, isLoading, showErrorMessage } = usePasswordRecovery();

  return (
    <FullScreenPageContainer isLoading={isLoading}>
      <h2 className="text-4xl font-sans mb-4 font-medium">Enter your email</h2>
      <div className="flex">
        <p className="font-sans text-tertiary">
          Enter your email address to request a reset password link.
        </p>
      </div>

      <DataForm form={form} onValid={onValid}>
        <div className="mt-8 md:max-w-sm">
          <TextField name="email" placeholder="Email" hideSuccessIcon={true} />
        </div>

        {showErrorMessage && (
          <p className="typography-btn-small text-destructive">
            Error while requesting password reset. Please try again in a few
            minutes.
          </p>
        )}

        <Button
          type="submit"
          className="md:max-w-sm py-3 text-white font-semibold bg-black rounded-lg mt-4"
        >
          Request password reset
        </Button>
      </DataForm>
    </FullScreenPageContainer>
  );
};
